// import React from "react";
import SEO from "../../components/seo/seo";  
import Button from "../../components/button/Button.jsx";
import "./about.css";
import OurVisionImage from "../../assets/OurVisionImage.webp";
import OurValueImage from "../../assets/OurValueImage.webp";
import NavBar from "../../Nav Bar/NavBar.jsx";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";

const About = () => {
  return (
    <>
      <SEO 
        title="About GiftCard8 - Secure and Reliable Gift Card Trading" 
        description="Learn more about GiftCard8, our vision, values, and why we are the best platform for secure and rewarding gift card trading."
        url="https://giftcard8.com/about-us"
      />

      <NavBar />
      <div className="about_container">
        <div className="container d-flex flex-column justify-content-center align-items-center px-2 px-md-4 px-lg-5 head" style={{ margin: "10% 0px" }}>
          <h1 className="text-center fw-bold my-4" style={{ fontSize: "clamp(3.5rem, 5vw, 4rem)" }}>
            About Us
          </h1>
          <p className="w-100 text-center fs-6 fs-md-5 px-2 px-md-3">
            Welcome to GiftCard8. Simplifying gift card solutions with ease and reliability since 2018.
          </p>
        </div>
      </div>

      <div className="container aboutSection" style={{ width: "87%" }}>
        <hr style={{ marginTop: "3%", border: "2px solid #777" }} />
        
        <div className="row my-5 text-start">
          <div className="col mx-2">
            <h1 style={{ color: "#0C7C85", display: "flex", alignItems: "center", fontSize: "52px" }}>
              1M+ <span style={{ color: "#000", fontSize: "18px", marginLeft: "5px" }}>Customers</span>
            </h1>
          </div>
          <div className="col mx-2">
            <h1 style={{ color: "#0C7C85", display: "flex", alignItems: "center", fontSize: "52px" }}>
              20M+ <span style={{ color: "#000", fontSize: "18px", marginLeft: "5px" }}>Orders</span>
            </h1>
          </div>
          <div className="col mx-2">
            <h1 style={{ color: "#0C7C85", display: "flex", alignItems: "center", fontSize: "52px" }}>
              60K+ <span style={{ color: "#000", fontSize: "18px", marginLeft: "5px" }}>App Downloads</span>
            </h1>
          </div>
        </div>
        <hr style={{ margin: "5% 0", border: "2px solid #777" }} />

        <div className="container vision_section position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 textSection">
              <h1 className="text-start fw-bold">Our Vision</h1>
              <p>At GiftCard8, our vision is to revolutionize gift card exchange in Africa and Asia, prioritizing:</p>
              <p>- Unparalleled customer satisfaction</p>
              <p>- Lucrative rewards for every user</p>
            </div>
            <div className="col-lg-6 col-md-6 text-center">
              <LazyLoad>
                <img src={OurVisionImage} className="vision_img position-absolute bottom-0 end-0" alt="Our Vision" />
              </LazyLoad>
            </div>
          </div>
        </div>

        <hr style={{ margin: "5% 0", border: "2px solid #777" }} />

        <div className="container values_section position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 text-center">
              <LazyLoad>
                <img src={OurValueImage} className="values_img position-absolute bottom-0 start-0" alt="Our Values" />
              </LazyLoad>
            </div>
            <div className="col-lg-6 col-md-6 text-start d-flex flex-column justify-content-center textSection">
              <h1 className="text-start w-100 fw-bold">Our Values</h1>
              <ul>
                <li className="mb-3 d-flex flex-row">
                  <i className="bi bi-check-circle me-2"></i>
                  <div><strong>Customer First:</strong> Your needs are always our highest priority.</div>
                </li>
                <li className="mb-3 d-flex flex-row">
                  <i className="bi bi-check-circle me-2"></i>
                  <div><strong>Honesty and Transparency:</strong> Transparent transactions, rest assured to use.</div>
                </li>
                <li className="d-flex flex-row">
                  <i className="bi bi-check-circle me-2"></i>
                  <div><strong>Innovation Driven:</strong> We pursue technology to enhance your experience.</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr style={{ margin: "5% 0", border: "2px solid #777" }} />
      </div>

      <section className="w-100 py-5 text-center bg-light">
        <div className="container">
          <h1 className="mb-3 fs-1 fw-bold">Why Choose Us</h1>
          <p className="text-muted mb-5">Outstanding customer experience & Rewarding benefits for all users</p>
          <div className="row my-5">
            <div className="col-md-4 mb-4">
              <h3 className="fw-bold">Fast and Secure</h3>
              <p className="text-muted">Our automated exchange process ensures that you can complete transactions quickly and safely.</p>
            </div>
            <div className="col-md-4 mb-4">
              <h3 className="fw-bold">Rich Rewards</h3>
              <p className="text-muted">We offer various rewards and promotional activities to make every transaction a delightful surprise.</p>
            </div>
            <div className="col-md-4 mb-4">
              <h3 className="fw-bold">Excellent Support</h3>
              <p className="text-muted">Our customer service team is available 24/7 to answer your questions and provide needful assistance.</p>
            </div>
          </div>
          <NavLink to="/contact-us" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none" }}>
            <div className="w-100 d-flex justify-content-center align-items-center">
              <Button className="w-25 responsive-button hover-effect contBtn" id="contactUsBtn">Contact Us</Button>
            </div>
          </NavLink>
        </div>
      </section>
    </>
  );
};

export default About;
